import { defineEvent } from '../types/event';
export var CART_ADD_QUICKVIEW = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'Add_to_Cart_QuickView'
        }
    ]
});
